import NotificationsTabContent from '../NotificationsTabContent';

/**
 * Notifications Locations
 */
const NotificationsLocations = () => <NotificationsTabContent category="locations" />;

export default NotificationsLocations;
